module.exports = __webpack_public_path__ + "img/payments.d60678d1.svg";